<template>
  <tr>
    <td>
      <div class="syonet-connection--name">{{ syonetConnection.name }}</div>
      <small>{{ syonetConnection.database_name }}</small>
    </td>
    <td>{{ syonetConnection.host }}:{{ syonetConnection.port }}</td>
    <td>{{ getScheduleLabel(syonetConnection.rule_cron) }}</td>
    <td>
      <woot-switch
        size="small"
        :value="syonetConnection.active"
        @input="updateActive"
      />
    </td>
    <td>{{ formatDateTime(syonetConnection.last_run_at) }}</td>
    <td class="button-wrapper">
      <woot-button
        v-tooltip.top="$t('INTEGRATION_SETTINGS.SYONET.EDIT.BUTTON_TEXT')"
        variant="smooth"
        size="tiny"
        color-scheme="secondary"
        icon="edit"
        @click="$emit('edit', syonetConnection)"
      />
      <woot-button
        v-tooltip.top="$t('INTEGRATION_SETTINGS.SYONET.DELETE.BUTTON_TEXT')"
        variant="smooth"
        color-scheme="alert"
        size="tiny"
        icon="dismiss-circle"
        @click="$emit('delete', syonetConnection)"
      />
    </td>
  </tr>
</template>

<script>
import format from 'date-fns/format';
import alertMixin from 'shared/mixins/alertMixin';
import { getScheduleLabel } from './scheduleOptions';

export default {
  mixins: [alertMixin],
  props: {
    syonetConnection: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getScheduleLabel,
    formatDateTime(value) {
      if (!value) {
        return '-';
      }

      return format(new Date(value), 'dd/MM/yyyy - HH:mm');
    },
    async updateActive(active) {
      try {
        await this.$store.dispatch('syonetConnections/update', {
          id: this.syonetConnection.id,
          syonet_connection: { active },
        });
        this.showAlert(
          this.$t('INTEGRATION_SETTINGS.SYONET.EDIT.API.SUCCESS_MESSAGE')
        );
      } catch (error) {
        const message =
          error.response?.data?.message ||
          this.$t('INTEGRATION_SETTINGS.SYONET.EDIT.API.ERROR_MESSAGE');
        this.showAlert(message);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.syonet-connection--name {
  color: var(--s-700);
  font-weight: var(--font-weight-medium);
  word-break: break-word;
}

.button-wrapper {
  max-width: var(--space-mega);
  min-width: auto;

  button:nth-child(2) {
    margin-left: var(--space-normal);
  }
}
</style>
